import { useQuery } from "@tanstack/react-query";
import chatsService from "services/admin/chatsService";

interface UseGetChatsProps {
    orgID: string;
    source: string;
    externalAccountUserName: string;
    query?: string;
}
export const useGetChats = ({ orgID, source, externalAccountUserName, query = '' }: UseGetChatsProps) => {
    return useQuery({
        enabled: !!orgID && !!source && !!externalAccountUserName,
        queryKey: ['chats', orgID, source, externalAccountUserName, query],
        queryFn: async () => {
            const response = await chatsService.getChats({
                orgID,
                source,
                externalAccountUserName,
                query,
            });
            return response.data?.rows || [];
        },
        retry: false,
        refetchOnWindowFocus: true,
    })
}